<template>
  <div id="app">
    <NavigationBar class="d-none d-lg-block"/>
    <MobileMenu />
    <BrandNavigation v-if="$route.name == 'Brand'" />
    <TypeNavigation v-if="$route.name == 'Type'" />
    <FooterNavigation />

    <transition
      :name="transitionName"
    >
      <router-view :key="routerKey"/>
    </transition>
  </div>
</template>

<script>
const DEFAULT_TRANSITION = 'tab'

import NavigationBar from '@/components/NavigationBar'
import MobileMenu from '@/components/MobileMenu'
import BrandNavigation from '@/components/BrandNavigation'
import TypeNavigation from '@/components/TypeNavigation'
import FooterNavigation from '@/components/FooterNavigation'

export default {
  components: {
     NavigationBar, MobileMenu, BrandNavigation, TypeNavigation, FooterNavigation
  },
  data() {
    return {
      transitionName: DEFAULT_TRANSITION
    }
  },
  created(){
    this.$router.beforeEach((to, from, next) => {
      // console.log(from.params, to.params)
      if (to.params.notransition) {
        this.transitionName = transitionName || DEFAULT_TRANSITION;
        next()
        return
      }
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        const toPath = to.path.split('/')
        const toDepth = toPath[1] == ''? 1: toPath.length;
        
        const fromPath = from.path.split('/')
        const fromDepth = fromPath[1] == ''? 1: fromPath.length;
        if (to.params.brandArrayIndex && from.params.brandArrayIndex) {
          if (from.params.brandArrayIndex > to.params.brandArrayIndex) {
            transitionName = 'slide-up';
          } else {
            transitionName = 'slide-down';
          }
        } else if (to.params.typeArrayIndex && from.params.typeArrayIndex) {
          if (parseInt(from.params.typeArrayIndex) > parseInt(to.params.typeArrayIndex)) {
            transitionName = 'slide-up';
          } else {
            transitionName = 'slide-down';
          }
        } else {
          transitionName = toDepth < fromDepth ? 'slide-up' : 'slide-down';
        }
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },
  mounted() {
      // window.addEventListener('scroll', this.handleScroll);
  },
  computed: {
    routerKey() {
      if (this.$route.name === 'Home') {
        return this.$route.name
      } else {
        return this.$route.fullPath
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
.slide-down-enter {
  transform: translate(0px, 100px);
  opacity: 0;
}
.slide-down-enter-to {
  opacity: 1;
}
.slide-down-enter-active {
  transition: all .6s 0s ease;
  position: fixed;
  top: 0;
}
.slide-down-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.slide-down-leave-to {
  transform: translate(0px, -100px);
  opacity: 0;
}
.slide-down-leave-active {
  transition: all .3s 0s ease;
  // .swiper-wrapper {
  //   transform: translate3d(-200vw, 0px, 0px);
  // }
  // &.swipe-1 {
  //   .swiper-wrapper {
  //     transform: translate3d(-100vw, 0px, 0px);
  //   }
  // }
}

.slide-up-enter {
  transform: translate(0px, -100px);
  opacity: 0;
}
.slide-up-enter-to {
  opacity: 1;
}
.slide-up-enter-active {
  transition: all .6s 0s ease;
  position: fixed;
  top: 0;
}
.slide-up-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.slide-up-leave-to {
  transform: translate(0px, 100px);
  opacity: 0;
}
.slide-up-leave-active {
  transition: all .3s 0s ease;
}
</style>
